import { render } from "./ProposalsList.vue?vue&type=template&id=1459baa2"
import script from "./ProposalsList.vue?vue&type=script&lang=js"
export * from "./ProposalsList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Song\\Documents\\Fun\\snapshot\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__